import classNames from "classnames";
import * as React from "react";
import { hot } from "react-hot-loader";
import { IInputInfo } from '../../../interfaces/IInputInfo';
import FormulaireFileInput from '../FormulaireFileInput/FormulaireFileInput';
import FormulaireInput from '../FormulaireInput/FormulaireInput';
import { IFormulaireCategorieProps } from './IFormulaireCategorieProps';
import { IFormulaireCategorieState } from './IFormulaireCategorieState';
declare var libelle: any;

class FormulaireCategorie extends React.Component<IFormulaireCategorieProps, IFormulaireCategorieState> {

    constructor(props: IFormulaireCategorieProps) {
        super(props);
        const formInputInfosInit: IInputInfo[] = [];

        this.props.categorieFormList.map((formInput) => {
            formInputInfosInit[formInput] = {
                IsValid: false,
                IsReady: false,
            }
        });

        this.state = {
            formInputInfos: formInputInfosInit,
            allInputReady: false,
            allInputValid: false,
        };

        this.OnInputIsReady = this.OnInputIsReady.bind(this);
        this.OnInputIsValid = this.OnInputIsValid.bind(this);
    }

    public render() {

        const formListRender = this.props.categorieFormList.map((formInput, key) => {
            if (this.props.InputFormSharePointList[formInput] != null && this.props.InputFormSharePointList[formInput].IsFileInput) {
                return (
                    <FormulaireFileInput key={key} PJSharePointList={this.props.PJSharePointList} loginName={this.props.loginName}
                        InputFormSharePointList={this.props.InputFormSharePointList} InputFormSharePoint={this.props.InputFormSharePointList[formInput]} candidatureId={this.props.candidatureId}
                        OnInputIsReady={this.OnInputIsReady} OnInputIsValid={this.OnInputIsValid} OnInputChange={this.props.OnInputChange} />
                );
            } else {
                return (
                    this.props.InputFormSharePointList[formInput] != null &&
                    <FormulaireInput key={key} loginName={this.props.loginName}
                        InputFormSharePointList={this.props.InputFormSharePointList} InputFormSharePoint={this.props.InputFormSharePointList[formInput]} candidatureId={this.props.candidatureId}
                        OnInputIsReady={this.OnInputIsReady} OnInputIsValid={this.OnInputIsValid} OnInputChange={this.props.OnInputChange} />
                );
            }
        });

        const isExpendedPanelClass = classNames('btn font-weight-bold text-left text-white w-100',
            { 'collapsed': false }
        );

        const isShowCollapseClass = classNames('collapse',
            { 'show': true }
        )

        const isValidClass = classNames('card-header panel-header',
            { 'bg-secondary': this.state.allInputValid || !this.state.allInputReady, 'bg-danger': !this.state.allInputValid && this.state.allInputReady }
        );

        return (
            <div className="card">
                <div className={isValidClass} id={"heading_" + this.props.categorieName}>
                    <div className="d-flex flex-row">
                        <h2 className="mb-0 w-100">
                            <button className={isExpendedPanelClass} type="button" data-toggle="collapse"
                                data-target={"#" + this.props.categorieName} aria-expanded={true} aria-controls={this.props.categorieName} >
                                {libelle.formulaireCandidature[this.props.categorieName]}
                            </button>
                        </h2>
                    </div>
                </div>

                <div id={this.props.categorieName} className={isShowCollapseClass}
                    aria-labelledby={"heading_" + this.props.categorieName}>
                    <div className="card-body">
                        {(this.props.categorieName === 'Diplomes'
                            || this.props.categorieName === 'Bourses'
                            || this.props.categorieName === 'Filiation'
                            || this.props.categorieName === 'Revenus') &&
                            <h5 className="text-danger mb-3">{libelle.formulaireCandidature.warningText}</h5>
                        }
                        {formListRender}
                    </div>
                </div>
            </div>
        );
    }

    private OnInputIsValid(inputKey: string, isValid: boolean): void {

        this.state = {
            ...this.state,
            formInputInfos: {
                ...this.state.formInputInfos,
                [inputKey]: {
                    ...this.state.formInputInfos[inputKey],
                    IsValid: isValid,
                }
            }
        }

        let allIsValid = true;

        Object.keys(this.state.formInputInfos).map((key, index) => {
            if (!this.state.formInputInfos[key].IsValid) {
                allIsValid = false;
                return;
            }
        });

        this.setState({ ...this.state, allInputValid: allIsValid });

        this.props.OnCategorieIsValid(this.props.categorieName, allIsValid);
    }

    private OnInputIsReady(inputKey: string): void {

        this.state = {
            ...this.state,
            formInputInfos: {
                ...this.state.formInputInfos,
                [inputKey]: {
                    ...this.state.formInputInfos[inputKey],
                    IsReady: true,
                }
            }
        }

        let allIsReady = true;

        Object.keys(this.state.formInputInfos).map((key, index) => {
            if (!this.state.formInputInfos[key].IsReady) {
                allIsReady = false;
                return;
            }
        });

        this.setState({ ...this.state, allInputReady: allIsReady });

        if (allIsReady) {
            this.props.OnCategorieIsReady(this.props.categorieName);
        }
    }
}

export default hot(module)(FormulaireCategorie);
